/**
 * UserDetailPresenter
 * --
 */
import React from 'react';

const UserDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>UserDetailPresenter</p>
    </div>
  );
};

export default UserDetailPresenter;
